var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show_box"},[_c('PrivateShow')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }